import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function TermsPage() {
  return <div className="min-h-screen" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-426">
      <Navigation data-id="element-427" />

      <div className="pt-32 pb-20 px-4" data-id="element-428">
        <div className="max-w-4xl mx-auto" data-id="element-429">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-430">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{
            color: 'var(--text-primary)'
          }} data-id="element-431">
              Terms of{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-432">
                Service
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-433">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>

            <div className="space-y-8" data-id="element-434">
              <Section title="1. Agreement to Terms" data-id="element-435">
                <p data-id="element-436">
                  By accessing or using XMonsters Agency's services, you agree
                  to be bound by these Terms of Service. If you disagree with
                  any part of these terms, you may not use our services.
                </p>
              </Section>

              <Section title="2. Services Description" data-id="element-437">
                <p data-id="element-438">
                  XMonsters Agency provides professional web design and
                  development services, including:
                </p>
                <ul data-id="element-439">
                  <li data-id="element-440">Free website demo creation</li>
                  <li data-id="element-441">Custom website design and development</li>
                  <li data-id="element-442">Website hosting setup assistance</li>
                  <li data-id="element-443">30 days of post-launch support</li>
                </ul>
              </Section>

              <Section title="3. Pricing and Payment" data-id="element-444">
                <p data-id="element-445">
                  <strong data-id="element-446">Free Demo:</strong> We provide a free website demo
                  with no obligation. You only pay if you approve the design and
                  want to launch.
                </p>
                <p data-id="element-447">
                  <strong data-id="element-448">Professional Package (€299):</strong> One-time payment
                  for complete website. Payment required after demo approval
                  before final launch.
                </p>
                <p data-id="element-449">
                  <strong data-id="element-450">Hosting (€10/month):</strong> Optional hosting and
                  maintenance service.
                </p>
                <p data-id="element-451">
                  All prices are in Euros (EUR). Payments are non-refundable
                  once work has commenced.
                </p>
              </Section>

              <Section title="4. Project Timeline" data-id="element-452">
                <p data-id="element-453">
                  Standard projects are completed within 24 hours from demo
                  approval. Timeline may vary based on:
                </p>
                <ul data-id="element-454">
                  <li data-id="element-455">Project complexity</li>
                  <li data-id="element-456">Client feedback response time</li>
                  <li data-id="element-457">Content availability</li>
                </ul>
              </Section>

              <Section title="5. Revisions and Changes" data-id="element-458">
                <p data-id="element-459">
                  Our package includes 3 rounds of revisions. Additional
                  revisions may incur extra charges. Major scope changes after
                  approval may require additional fees.
                </p>
              </Section>

              <Section title="6. Intellectual Property" data-id="element-460">
                <p data-id="element-461">
                  Upon full payment, you own all rights to the final website
                  design and code. Before payment, all work remains property of
                  XMonsters Agency.
                </p>
              </Section>

              <Section title="7. Client Responsibilities" data-id="element-462">
                <p data-id="element-463">Clients are responsible for:</p>
                <ul data-id="element-464">
                  <li data-id="element-465">Providing accurate content and materials</li>
                  <li data-id="element-466">Timely feedback and approvals</li>
                  <li data-id="element-467">
                    Domain registration and hosting (if not using our services)
                  </li>
                  <li data-id="element-468">Compliance with applicable laws</li>
                </ul>
              </Section>

              <Section title="8. Limitation of Liability" data-id="element-469">
                <p data-id="element-470">
                  XMonsters Agency is not liable for indirect, incidental, or
                  consequential damages arising from use of our services. Our
                  total liability is limited to the amount paid for services.
                </p>
              </Section>

              <Section title="9. Termination" data-id="element-471">
                <p data-id="element-472">
                  Either party may terminate the agreement with written notice.
                  Payments for completed work are non-refundable.
                </p>
              </Section>

              <Section title="10. Contact" data-id="element-473">
                <p data-id="element-474">For questions about these Terms, contact us at:</p>
                <p data-id="element-475">
                  Email: legal@xmonsters.agency
                  <br data-id="element-476" />
                  Telegram: @xmonstersagency
                </p>
              </Section>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-477" />
      <CookieBanner data-id="element-478" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border p-6 sm:p-8" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-479">
      <h2 className="text-xl sm:text-2xl font-bold mb-4" style={{
      color: 'var(--text-primary)'
    }} data-id="element-480">
        {title}
      </h2>
      <div className="space-y-3 text-sm sm:text-base [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:space-y-2" style={{
      color: 'var(--text-secondary)'
    }} data-id="element-481">
        {children}
      </div>
    </div>;
}